export default __webpack_public_path__ + "static/assets/med_pill_square_in_L0_solid_x_01_f_mask.cf349c13.png";